<template>
  <input type="checkbox" v-model="checked" :indeterminate.prop="someChecked && !checked" @change="handleChange"/>
</template>

<script>
export default {
  name: 'SelectAllRenderer',
  props: {
    tableData: {
      type: Array
    }
  },
  data: () => ({
      checked: false,
      someChecked: false
  }),
  methods: {
    handleChange: function() {
      this.$emit("onSelectAll", this.checked)
    }
  },
  watch: {
      tableData: {
        deep: true,
        handler: function(val) {
          const selectedMap = val.map(row => row.selected);
          this.someChecked = selectedMap.some(selected => selected);
          this.checked = selectedMap.every(selected => selected);
        }
      }
  }
}
</script>
  